module.exports = __webpack_public_path__ + "static/media/p1_5.7956ab2f.png";